import { render, staticRenderFns } from "./NewHearAboutUs.vue?vue&type=template&id=2bd7f57a&scoped=true&"
import script from "./NewHearAboutUs.vue?vue&type=script&lang=js&"
export * from "./NewHearAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./NewHearAboutUs.vue?vue&type=style&index=0&id=2bd7f57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd7f57a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd7f57a')) {
      api.createRecord('2bd7f57a', component.options)
    } else {
      api.reload('2bd7f57a', component.options)
    }
    module.hot.accept("./NewHearAboutUs.vue?vue&type=template&id=2bd7f57a&scoped=true&", function () {
      api.rerender('2bd7f57a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/dev/linkedin/NewHearAboutUs.vue"
export default component.exports